import { Spin, theme } from 'antd'
import { FileImageOutlined } from '@ant-design/icons'

import type { FileStatus } from './useDisplaySources'

type FilePlaceholderProps = {
  status: FileStatus
  compact?: boolean
}

export const FilePlaceholder = ({
  status,
  compact = false,
}: FilePlaceholderProps) => {
  const { token } = theme.useToken()

  if (status === 'converting') {
    return <Spin size={compact ? 'small' : 'default'} />
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        color: token.colorTextTertiary,
      }}
      title="This file could not be displayed"
    >
      <FileImageOutlined style={{ fontSize: compact ? 20 : 32 }} />
      {!compact && <span style={{ fontSize: 12 }}>Preview unavailable</span>}
    </div>
  )
}
